import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

function DialogHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("flex flex-col gap-1.5 text-center sm:text-left", className)} {...props} />;
}

export { DialogHeader };
